<template>
  <div id="ano" style="padding-bottom: 30px;">
    <div class="top-header1">
      <img
        src="/sandboxfront/mapatributario/logo_mini.svg"
        alt=""
        style="margin:30px 0px;"
      />
      <div class="title">
        <div style="display: flex;justify-content: left; gap: 8px;">
          <img
            src="https://www.lefisc.com.br/consultaGtin/images/consult.svg"
            alt=""
          />
          <h2 style="color:#fff;font-weight: 400;margin:0px;">
            {{ $route.params.ncm }}
          </h2>
        </div>
      </div>
      <div
        style="display: flex; justify-content: start; width: 100%; max-width: 1200px;margin: 0 auto;"
      >
        <p style="color:#fff;    margin-bottom: 0;">
          <span style="font-weight:600">UF:</span> {{ $route.params.uf }}
        </p>
        <p style="color:#fff;margin-left: 15px;    margin-bottom: 0;">
          <span style="font-weight:600"> Categoria:</span> {{ observacao }}
        </p>
      </div>
    </div>

    <div class="container-seletor">
      <div class="item"></div>
      <div class="conteudoIcmsIpi" style="margin-top:30px">
        <div class="container-excessao"><h2>Informações da NCM</h2></div>
        <div class="headerIcmsIpi" @click="ipiT = !ipiT">
          <img
            src="/sandboxfront/mapatributario/setaPre.svg"
            alt=""
            :style="{
              'margin-right': '10px',
              transform: ipiT ? 'rotate(180deg)' : 'rotate(0deg)',
            }"
          />
          <span>IPI</span>
        </div>
        <div
          class="espacamento"
          :style="{ display: ipiT ? 'none' : 'inherit' }"
        >
          <span class="txtBo">IPI: </span> <span v-if="ipi">{{ ipi }}</span
          ><span v-else>Nenhum dispositivo legal cadastrado</span>
        </div>
      </div>
      <div class="conteudoIcmsIpi">
        <div class="headerIcmsIpi" @click="icmsT = !icmsT">
          <img
            src="/sandboxfront/mapatributario/setaPre.svg"
            alt=""
            :style="{
              'margin-right': '10px',
              transform: icmsT ? 'rotate(180deg)' : 'rotate(0deg)',
            }"
          />
          <span>ICMS</span>
        </div>
        <div
          class="aliquotas espacamento"
          :style="{ display: icmsT ? 'none' : 'inherit' }"
        >
          <div>
            <span class="txtBo">Alíquota ICMS: </span>
            <span v-if="aliquotas">{{ aliquotas }}%</span>
            <span v-else>Não tem alíquota ICMS registradas</span>
          </div>
          <div style="margin-top:20px;">
            <span class="txtBo">[Nota Lefisc]: </span>
            <div
              v-if="aliquotasNotas"
              v-html="aliquotasNotas"
              style="font-size:15px;"
            ></div>
            <div v-else>
              Não tem
            </div>
            <div class="notaPobreza">
              <span class="txtPobreza"
                ><span class="txtWarning"> NOTA: </span>Para informações do
                Fundo de Combate a Pobreza
                <a
                  href="https://www.lefisc.com.br/boletins/2020/setembro_semana_4/fundo_amparo_pobreza/index.asp"
                  target="_blank"
                  >clique aqui</a
                ></span
              >
            </div>
          </div>
        </div>
        <div
          class="isencoes espacamento"
          :style="{ display: icmsT ? 'none' : 'inherit' }"
        >
          <div
            @click="lerMaisIsencoes()"
            style="display: flex;align-items: center; cursor: pointer;"
          >
            <img
              src="/sandboxfront/mapatributario/setaBaixo.svg"
              alt=""
              width="18px"
              :class="{ viraSeta: boolIsencoes }"
            />
            <span class="txtBo" style="margin:0px 6px;">Isenções:</span>
          </div>
          <div v-show="boolIsencoes" style="font-size:15px; margin-left: 25px;">
            <div v-if="listIsencoes">
              <div v-for="(item, index) of listIsencoes" :key="index">
                <div style="border-bottom: 1px solid #4A154B">
                  <p v-html="item.notas"></p>
                  <p>CBenef: {{ item.cbenef }}</p>
                </div>
              </div>
            </div>
            <div v-else>
              Nenhum dispositivo legal cadastrado
            </div>
          </div>
        </div>
        <div
          class="reducoes espacamento"
          :style="{ display: icmsT ? 'none' : 'inherit' }"
        >
          <div
            @click="lerMaisReducoes()"
            style="display: flex;align-items: center; cursor: pointer;"
          >
            <img
              src="/sandboxfront/mapatributario/setaBaixo.svg"
              alt=""
              width="18px"
              :class="{ viraSeta: boolReducoes }"
            />
            <span class="txtBo" style="margin:0px 6px;">Reduções:</span>
          </div>

          <div v-show="boolReducoes" style="font-size:15px; margin-left: 25px;">
            <div v-if="listBeneficios" style="margin:0px 6px;">
              <div v-for="(item, index) of listBeneficios" :key="index">
                <div style="border-bottom: 1px solid #4A154B">
                  <p v-html="item.notas"></p>
                  <p>CBenef: {{ item.cbenef }}</p>
                </div>
              </div>
            </div>
            <div v-else>
              Nenhum dispositivo legal cadastrado
            </div>
          </div>
        </div>
        <div
          class="isencoes espacamento"
          :style="{ display: icmsT ? 'none' : 'inherit' }"
        >
          <div
            @click="boolCreditoPresumid = !boolCreditoPresumid"
            style="display: flex;align-items: center; cursor: pointer;"
          >
            <img
              src="/sandboxfront/mapatributario/setaBaixo.svg"
              alt=""
              width="18px"
              :class="{ viraSeta: boolCreditoPresumid }"
            />
            <span class="txtBo" style="margin:0px 6px;"
              >Crédito Presumido:</span
            >
          </div>
          <div
            style="font-size:15px; margin-left: 25px;"
            v-show="boolCreditoPresumid"
          >
            <div v-if="listCreditoPresumido">
              <div v-for="(item, index) of listCreditoPresumido" :key="index">
                <div style="border-bottom: 1px solid #4A154B">
                  <p v-html="item.notas"></p>
                  <p>CBenef: {{ item.cbenef }}</p>
                </div>
              </div>
            </div>
            <div v-else>
              Nenhum dispositivo legal cadastrado
            </div>
          </div>
        </div>
        <div
          class="isencoes espacamento"
          :style="{ display: icmsT ? 'none' : 'inherit' }"
        >
          <div
            @click="boolDiferimento = !boolDiferimento"
            style="display: flex;align-items: center; cursor: pointer;"
          >
            <img
              src="/sandboxfront/mapatributario/setaBaixo.svg"
              alt=""
              width="18px"
              :class="{ viraSeta: boolDiferimento }"
            />
            <span class="txtBo" style="margin:0px 6px;">Diferimento:</span>
          </div>
          <div
            style="font-size:15px; margin-left: 25px;"
            v-show="boolDiferimento"
          >
            <div v-if="listDiferimento">
              <div v-for="(item, index) of listDiferimento" :key="index">
                <div style="border-bottom: 1px solid #4A154B">
                  <p v-html="item.notas"></p>
                  <p>CBenef: {{ item.cbenef }}</p>
                </div>
              </div>
            </div>
            <div v-else>
              Nenhum dispositivo legal cadastrado
            </div>
          </div>
        </div>
        <div
          class="isencoes espacamento"
          :style="{ display: icmsT ? 'none' : 'inherit' }"
        >
          <div
            @click="boolNaoIncidenci = !boolNaoIncidenci"
            style="display: flex;align-items: center; cursor: pointer;"
          >
            <img
              src="/sandboxfront/mapatributario/setaBaixo.svg"
              alt=""
              width="18px"
              :class="{ viraSeta: boolNaoIncidenci }"
            />
            <span class="txtBo" style="margin:0px 6px;">Não-Incidência:</span>
          </div>
          <div
            style="font-size:15px; margin-left: 25px;"
            v-show="boolNaoIncidenci"
          >
            <div v-if="listNaoIncidencia">
              <div v-for="(item, index) of listNaoIncidencia" :key="index">
                <div style="border-bottom: 1px solid #4A154B">
                  <p v-html="item.notas"></p>
                  <p>CBenef: {{ item.cbenef }}</p>
                </div>
              </div>
            </div>
            <div v-else>
              Nenhum dispositivo legal cadastrado
            </div>
          </div>
        </div>
        <div
          class="isencoes espacamento"
          :style="{ display: icmsT ? 'none' : 'inherit' }"
        >
          <div
            @click="boolSuspensao = !boolSuspensao"
            style="display: flex;align-items: center; cursor: pointer;"
          >
            <img
              src="/sandboxfront/mapatributario/setaBaixo.svg"
              alt=""
              width="18px"
              :class="{ viraSeta: boolSuspensao }"
            />
            <span class="txtBo" style="margin:0px 6px;">Suspensão:</span>
          </div>
          <div
            style="font-size:15px; margin-left: 20px;"
            v-show="boolSuspensao"
          >
            <div v-if="listSuspensao" style="margin:0px 6px;">
              <div v-for="(item, index) of listSuspensao" :key="index">
                <div style="border-bottom: 1px solid #4A154B">
                  <p v-html="item.notas"></p>
                  <p>CBenef: {{ item.cbenef }}</p>
                </div>
              </div>
            </div>
            <div v-else>
              Nenhum dispositivo legal cadastrado
            </div>
          </div>
        </div>
      </div>
      <div class="conteudoIcmsIpi">
        <div class="headerIcmsIpi" @click="subTri = !subTri">
          <img
            src="/sandboxfront/mapatributario/setaPre.svg"
            alt=""
            :style="{
              'margin-right': '10px',
              transform: subTri ? 'rotate(180deg)' : 'rotate(0deg)',
            }"
          />
          <span>Substituição Tributária</span>
        </div>

        <div :style="{ display: subTri ? 'none' : 'inherit' }">
          <div v-if="digitos && digitos.length > 0">
            <div class="espacamento" v-for="(d, i) in digitos" :key="i">
              <div
                class="headerIcmsIpi"
                @click="arraySyb[i].isFalsa = !arraySyb[i].isFalsa"
              >
                <p style="font-size:16px">
                  <img
                    src="/sandboxfront/mapatributario/setaPre.svg"
                    alt=""
                    :style="{
                      'margin-right': '10px',
                      transform: arraySyb[i].isFalsa
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    }"
                  />
                </p>
                CEST: <span style=" margin-left: 5px;">{{ d.cest }}</span>
                <span style="margin:0 20px;">-</span>
                <p style="font-size:16px">
                  NCM:
                  <span v-for="(n, l) in d.ncm" :key="l">
                    {{ n }}{{ l != d.ncm.length - 1 ? "," : "" }}
                  </span>
                </p>
              </div>

              <div style="padding:8px" v-if="arraySyb[i].isFalsa">
                <span class="txtBo">Substituição Tributária:</span
                ><span>
                  NCM/<span v-for="(n, l) in d.ncm" :key="l"
                    >{{ n }}{{ l != d.ncm.length - 1 ? "," : "" }}</span
                  >
                  - {{ d.lista }}</span
                ><br />
                <span class="txtBo">{{ d.categoria }}:</span> {{ d.descricao
                }}<br />
                <div
                  style="display: grid;grid-template-columns: repeat(4,1fr); gap: 25px;"
                >
                  <div
                    v-for="(k, o) in d.ajusteMVA"
                    :key="o"
                    style="margin-top:10px"
                  >
                    <div
                      style=" display: inline-block;padding: 10px;border-radius: 5px; border: 2px solid #000;background: #f5f5f5;"
                    >
                      <div
                        style="margin-bottom:10px;display: flex; align-items: center;"
                      >
                        <span class="txtBo" style="margin-right: 5px;"
                          >MVA Interna:
                        </span>
                        {{ k[0] }}%
                        <div
                          style="position: relative;height: 16px;"
                          class="hover-info2"
                        >
                          <img
                            v-if="d.mva[o].especificacao != null"
                            src="https://www.lefisc.com.br/mapatributario/sa.svg"
                            alt=""
                            width="16"
                            style="margin-left: 15px;"
                          />
                          <div class="hover-text2">
                            {{ d.mva[o].especificacao }}
                          </div>
                          <br />
                        </div>
                      </div>
                      <span class="txtBo">MVA Ajustada 4% : </span>
                      {{ k[1][0].toFixed(5) }}%<br />
                      <span class="txtBo">MVA Ajustada 7% : </span>
                      {{ k[1][1].toFixed(5) }}%<br />
                      <span class="txtBo">MVA Ajustada 12% : </span>
                      {{ k[1][2].toFixed(5) }}%<br />
                    </div>
                  </div>
                </div>
                <p style="color:red;margin-bottom: 0;">
                  MVA Ajustada com base na alíquota interna do ICMS sem
                  considerar os adicionais previstos na legislação
                </p>
                <div v-for="(k, o) in d.regrasMVA" :key="o">
                  <div v-html="k.texto"></div>
                </div>
                <div style=" margin: 10px 0px;">
                  <span class="txtBo">CEST: </span>{{ d.cest }}<br />
                </div>

                <span class="txtBo" style="margin-bottom: 10px;"
                  >Estados Signatários:</span
                >
                <span style="color:red;font-size:14px;"
                  >Verificar hipóteses de exclusão de responsabilidade no
                  protocolo ou convênio</span
                >

                <tableSig :estados="d.signatarios"> </tableSig>
                <br />
                <span style="font-weight: 600;font-size: 16px;"
                  >Observações:</span
                >
                <div>
                  <ul v-for="(no, i) in d.nota" :key="i">
                    <li>{{ no }}</li>
                  </ul>
                </div>
                <ul>
                  <li v-for="(n, i) in d.observacoes" :key="i">
                    <div style="display:flex;align-items: center;">
                      <p
                        :style="{
                          'font-weight': 'bold',
                          'margin-right': '5px',
                          'text-decoration': n.link == null ? '' : 'underline',
                          cursor: n.link == null ? '' : 'pointer',
                        }"
                        @click="irParaLink(n.link)"
                      >
                        {{ n.baseLegal }}:
                      </p>
                      <span
                        style=" margin-right: 3px;"
                        v-for="(a, b) in n.estados"
                        :key="b"
                        >{{ a }}{{ n.estados.length - 1 > b ? ", " : "" }}</span
                      >
                    </div>
                  </li>
                </ul>
                <a
                  href="https://www.lefisc.com.br/st/simuladorCalculos/"
                  target="_blank"
                  style="display: block; margin-top: 5px;margin-top:10px;"
                >
                  Simulador Substituição Tributária
                </a>
              </div>
            </div>
          </div>

          <div v-else class="espacamento">
            <p>Nenhum dispositivo legal cadastrado</p>
          </div>
        </div>
      </div>
      <div class="conteudoIcmsIpi">
        <div class="headerIcmsIpi" @click="pisCo = !pisCo">
          <img
            src="/sandboxfront/mapatributario/setaPre.svg"
            alt=""
            :style="{
              'margin-right': '10px',
              transform: pisCo ? 'rotate(180deg)' : 'rotate(0deg)',
            }"
          />
          <span>PIS/COFINS</span>
        </div>
        <div
          class="espacamento"
          :style="{ display: pisCo ? 'none' : 'inherit' }"
        >
          <span class="txtBo">PIS/COFINS</span><br />
          <div v-if="!!cst_pis">
            <div v-for="(d, i) in cst_pis" :key="i">
              <span class="txtBo">{{ d.codigo }} - </span> {{ d.descricao }}
            </div>
          </div>
          <div v-else>
            Nenhum dispositivo legal cadastrado
          </div>
        </div>
        <div
          class="espacamento"
          :style="{ display: pisCo ? 'none' : 'inherit' }"
        >
          <div v-html="pis" v-if="pis"></div>
          <div v-else>Nenhum dispositivo legal cadastrado</div>
        </div>
      </div>

      <div class="conteudoIcmsIpi">
        <div class="headerIcmsIpi" @click="cstT = !cstT">
          <img
            src="/sandboxfront/mapatributario/setaPre.svg"
            alt=""
            :style="{
              'margin-right': '10px',
              transform: cstT ? 'rotate(180deg)' : 'rotate(0deg)',
            }"
          />
          <span>Reforma Tributária</span>
        </div>
        <div
          class="espacamento"
          :style="{ display: cstT ? 'none' : 'inherit' }"
        >
          <div v-if="cstLoading">
            <p>Carregando informações de CST...</p>
          </div>
          <div v-else>
            <div v-if="cstResults.length > 0">
              <div
                v-for="(item, index) in cstResults"
                :key="index"
                style="border-bottom: 1px solid #4A154B; padding-bottom: 15px; margin-bottom: 15px;"
              >
                <p>
                  <span class="txtBo">Código Categoria:</span>
                  {{ item.categoriaCodigo }}
                </p>
                <p>
                  <span class="txtBo">Categoria:</span> {{ item.categoriaDesc }}
                </p>
                <p><span class="txtBo">Código:</span> {{ item.codigo }}</p>
                <p>
                  <span class="txtBo">Descrição:</span> {{ item.descricao }}
                </p>
                <p><span class="txtBo">IBS:</span> {{ item.ibs }}</p>
                <p><span class="txtBo">CBS:</span> {{ item.cbs }}</p>
                <p>
                  <span class="txtBo">Redução Base de Cálculo: </span>
                  <span
                    v-if="item.bc === 'Sim'"
                    style="color: green; font-weight: bold; font-size: 1.2em;"
                    >&#10004;</span
                  >
                  <span
                    v-else-if="item.bc === 'Não'"
                    style="color: red; font-weight: bold; font-size: 1.2em;"
                    >&#10008;</span
                  >
                  <span v-else> {{ item.bc }}</span>
                </p>
                <p>
                  <span class="txtBo">Trib. Regular: </span>
                  <span
                    v-if="item.tribRegular === 'Sim'"
                    style="color: green; font-weight: bold; font-size: 1.2em;"
                    >&#10004;</span
                  >
                  <span
                    v-else-if="item.tribRegular === 'Não'"
                    style="color: red; font-weight: bold; font-size: 1.2em;"
                    >&#10008;</span
                  >
                  <span v-else> {{ item.tribRegular }}</span>
                </p>
                <p>
                  <span class="txtBo">Créd. Presumido: </span>
                  <span
                    v-if="item.credPresumido === 'Sim'"
                    style="color: green; font-weight: bold; font-size: 1.2em;"
                    >&#10004;</span
                  >
                  <span
                    v-else-if="item.credPresumido === 'Não'"
                    style="color: red; font-weight: bold; font-size: 1.2em;"
                    >&#10008;</span
                  >
                  <span v-else> {{ item.credPresumido }}</span>
                </p>
                <p>
                  <span class="txtBo">Estorno Crédito: </span>
                  <span
                    v-if="item.estornoCredito === 'Sim'"
                    style="color: green; font-weight: bold; font-size: 1.2em;"
                    >&#10004;</span
                  >
                  <span
                    v-else-if="item.estornoCredito === 'Não'"
                    style="color: red; font-weight: bold; font-size: 1.2em;"
                    >&#10008;</span
                  >
                  <span v-else> {{ item.estornoCredito }}</span>
                </p>
                <p>
                  <span class="txtBo">Tipo de Alíquota:</span>
                  {{ item.tipoAliquota }}
                </p>
                <p v-if="item.dfesRelacionados.length > 0">
                  <span class="txtBo">DFes Relacionados:</span>
                  {{ item.dfesRelacionados.join(", ") }}
                </p>
              </div>
            </div>
            <div v-else>
              <p>Nenhuma regra de CST específica encontrada para esta NCM.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container-excessao"><h2>Exceções da NCM</h2></div>
      <ex
        v-for="(d, i) in ncmDescIdExcessao"
        :key="i"
        :_NCMDescIdExcessao="d"
        style="margin-bottom:10px;"
      >
      </ex>
    </div>
  </div>
</template>

<script>
import index from "../services/index";
import ex from "../shared/ex";
import table from "../shared/table";

export default {
  components: {
    tableSig: table,
    ex: ex,
  },
  data() {
    return {
      arraySyb: [],
      ipiT: true,
      icmsT: true,
      subTri: true,
      pisCo: true,
      cstT: true, // Controla o "acordeão" do CST
      allCstData: [], // Armazena a resposta COMPLETA da API
      cstResults: [], // Armazena apenas os resultados FILTRADOS
      cstLoading: false,
      desaparecer: 0,
      spiner: false,
      descricao: "",
      dadosNcmUF: [],
      dadosNcm: [],
      boolIsencoes: false,
      boolReducoes: false,
      idEstado: 0,
      estados: [
        {
          id: 1,
          estado: "Acre",
          sigla: "AC",
          capital: "Rio Branco",
          codigoIBGE: 12,
        },
        {
          id: 2,
          estado: "Alagoas",
          sigla: "AL",
          capital: "Maceió",
          codigoIBGE: 27,
        },
        {
          id: 3,
          estado: "Amapá",
          sigla: "AP",
          capital: "Macapá",
          codigoIBGE: 16,
        },
        {
          id: 4,
          estado: "Amazonas",
          sigla: "AM",
          capital: "Manaus",
          codigoIBGE: 13,
        },
        {
          id: 5,
          estado: "Bahia",
          sigla: "BA",
          capital: "Salvador",
          codigoIBGE: 29,
        },
        {
          id: 6,
          estado: "Ceará",
          sigla: "CE",
          capital: "Fortaleza",
          codigoIBGE: 23,
        },
        {
          id: 7,
          estado: "Distrito Federal",
          sigla: "DF",
          capital: "Brasília",
          codigoIBGE: 53,
        },
        {
          id: 8,
          estado: "Espírito Santo",
          sigla: "ES",
          capital: "Vitória",
          codigoIBGE: 32,
        },
        {
          id: 9,
          estado: "Goiás",
          sigla: "GO",
          capital: "Goiânia",
          codigoIBGE: 52,
        },
        {
          id: 10,
          estado: "Maranhão",
          sigla: "MA",
          capital: "São Luís",
          codigoIBGE: 21,
        },
        {
          id: 11,
          estado: "Mato Grosso",
          sigla: "MT",
          capital: "Cuiabá",
          codigoIBGE: 51,
        },
        {
          id: 12,
          estado: "Mato Grosso do Sul",
          sigla: "MS",
          capital: "Campo Grande",
          codigoIBGE: 50,
        },
        {
          id: 13,
          estado: "Minas Gerais",
          sigla: "MG",
          capital: "Belo Horizonte",
          codigoIBGE: 31,
        },
        {
          id: 14,
          estado: "Pará",
          sigla: "PA",
          capital: "Belém",
          codigoIBGE: 15,
        },
        {
          id: 15,
          estado: "Paraíba",
          sigla: "PB",
          capital: "João Pessoa",
          codigoIBGE: 25,
        },
        {
          id: 16,
          estado: "Paraná",
          sigla: "PR",
          capital: "Curitiba",
          codigoIBGE: 41,
        },
        {
          id: 17,
          estado: "Pernambuco",
          sigla: "PE",
          capital: "Recife",
          codigoIBGE: 26,
        },
        {
          id: 18,
          estado: "Piauí",
          sigla: "PI",
          capital: "Teresina",
          codigoIBGE: 22,
        },
        {
          id: 19,
          estado: "Rio de Janeiro",
          sigla: "RJ",
          capital: "Rio de Janeiro",
          codigoIBGE: 33,
        },
        {
          id: 20,
          estado: "Rio Grande do Norte",
          sigla: "RN",
          capital: "Natal",
          codigoIBGE: 24,
        },
        {
          id: 21,
          estado: "Rio Grande do Sul",
          sigla: "RS",
          capital: "Porto Alegre",
          codigoIBGE: 43,
        },
        {
          id: 22,
          estado: "Rondônia",
          sigla: "RO",
          capital: "Porto Velho",
          codigoIBGE: 11,
        },
        {
          id: 23,
          estado: "Roraima",
          sigla: "RR",
          capital: "Boa Vista",
          codigoIBGE: 14,
        },
        {
          id: 24,
          estado: "Santa Catarina",
          sigla: "SC",
          capital: "Florianópolis",
          codigoIBGE: 42,
        },
        {
          id: 25,
          estado: "São Paulo",
          sigla: "SP",
          capital: "São Paulo",
          codigoIBGE: 35,
        },
        {
          id: 26,
          estado: "Sergipe",
          sigla: "SE",
          capital: "Aracaju",
          codigoIBGE: 28,
        },
        {
          id: 27,
          estado: "Tocantins",
          sigla: "TO",
          capital: "Palmas",
          codigoIBGE: 17,
        },
      ],
      visible: true,
      aliquotas: "",
      aliquotasNotas: "",
      isencoes: "",
      beneficios: "",
      ipi: "",
      digitos: [],
      cst_pis: [],
      pis: [],
      ncmDescIdExcessao: [],
      cestDes: "",
      cest: "",
      mva: {},
      arry: [],
      observacao: "",
      num: 0,
      CreditoPresumid: "",
      Diferimento: "",
      NaoIncidenci: "",
      Suspensao: "",
      boolSuspensao: false,
      boolCreditoPresumid: false,
      boolDiferimento: false,
      boolNaoIncidenci: false,
      listSuspensao: [],
      listNaoIncidencia: [],
      listDiferimento: [],
      listCreditoPresumido: [],
      listBeneficios: [],
      listIsencoes: [],
    };
  },
  methods: {
    irParaLink(link) {
      if (link != null) {
        window.open(link, "_blank");
      }
    },
    headerDesaparecer(num) {
      this.num = num;
      console.log(this.arry.includes(num));
      if (this.arry.includes(num)) {
        let a = this.arry.findIndex((e) => e == num);
        delete this.arry[a];
      } else {
        this.arry.push(num);
      }
      console.log(this.arry);
    },
    lerMaisIsencoes() {
      this.boolIsencoes = !this.boolIsencoes;
    },
    lerMaisReducoes() {
      this.boolReducoes = !this.boolReducoes;
    },

    /*
     * Busca todos os dados da API de CST.
     */
    async fetchCstData() {
      this.cstLoading = true;
      try {
        const response = await fetch(
          "https://www.lefisc.com.br/api/apiCst/csts",
        );
        if (!response.ok) {
          throw new Error("Falha ao buscar dados CST");
        }
        this.allCstData = await response.json();
        // Após carregar, chama o filtro
        this.filterCstData();
      } catch (error) {
        console.error("Erro ao carregar dados do CST:", error);
        this.cstResults = [];
      } finally {
        this.cstLoading = false;
      }
    },

    /**
     * Filtra a lista mestre de CST (allCstData)
     * e popula 'cstResults' apenas com os itens
     * que correspondem ao NCM da rota.
     */
    filterCstData() {
      const targetNcm = this.$route.params.ncm;
      const results = [];

      if (!this.allCstData || this.allCstData.length === 0) {
        this.cstResults = [];
        return;
      }

      // Itera por cada Categoria (Ex: "Tributação integral")
      for (const category of this.allCstData) {
        if (category.items && Array.isArray(category.items)) {
          // Itera por cada Item (regra) dentro da categoria
          for (const item of category.items) {
            // Verifica se o item POSSUI a lista 'ncms'
            if (item.ncms && Array.isArray(item.ncms)) {
              // Verifica se a NCM da rota existe dentro da lista 'ncms' do item
              // O .some() é eficiente, ele para assim que acha o primeiro
              const isMatch = item.ncms.some(
                (ncmEntry) => ncmEntry.NCM === targetNcm,
              );

              if (isMatch) {
                // Lista de possíveis DFes para checar
                const dfeKeys = [
                  "nfe",
                  "nfce",
                  "cte",
                  "cte_os",
                  "bpe",
                  "nf3e",
                  "nfcom",
                  "nfse",
                  "bpe_tm",
                  "bpe_ta",
                  "nfag",
                  "nfsvia",
                  "nfabi",
                  "nfgas",
                  "dere",
                ];

                const dfesRelacionados = [];
                for (const key of dfeKeys) {
                  if (item[key] === "Sim") {
                    dfesRelacionados.push(key.toUpperCase());
                  }
                }
                // Se achou, adiciona o item (e a descrição da categoria) nos resultados
                results.push({
                  codigo: item.codigo,
                  descricao: item.descricao,
                  categoriaDesc: category.descricao,
                  categoriaCodigo: category.codigo,
                  ibs: item.ibs,
                  cbs: item.cbs,
                  bc: item.reducao_bc,
                  tribRegular: item.tributacao_regular,
                  credPresumido: item.presumido,
                  estornoCredito: item.estorno_credito,
                  tipoAliquota: item.tipo_aliquota,
                  dfesRelacionados: dfesRelacionados,
                });
              }
            }
          }
        }
      }
      this.cstResults = results;
    },

    async listIcms() {
      await Promise.all([
        index.NcmEstadoSandBox(this.$route.params.ncm, this.$route.params.uf),
      ]).then(([dados]) => {
        console.log(dados);
        this.listSuspensao = dados[0]?._Suspensao;
        this.listNaoIncidencia = dados[0]?._NaoIncidencia;
        this.listDiferimento = dados[0]?._Diferimento;
        this.listCreditoPresumido = dados[0]?._CreditoPresumido;
        this.listBeneficios = dados[0]?._Beneficios;
        this.listIsencoes = dados[0]?._Isencoes;
      });
    },
    extrair(dados) {
      this.aliquotas =
        dados[0]._Aliquotas.length == 0 ? "" : dados[0]._Aliquotas[0].aliquotas;
      this.aliquotasNotas =
        dados[0]._Aliquotas.length == 0 ? "" : dados[0]._Aliquotas[0].notas;
      this.isencoes =
        dados[0]._Isencoes.length == 0 ? "" : dados[0]._Isencoes[0].notas;
      this.beneficios =
        dados[0]._Beneficios == 0 ? "" : dados[0]._Beneficios[0].notas;
      this.ipi =
        this.dadosNcm[0]._ipi.length == 0 ? "" : this.dadosNcm[0]._ipi[0].ipi;
      this.digitos = this.dadosSt != undefined ? this.dadosSt.produtos : null;
      this.CreditoPresumid = dados[0]._CreditoPresumido;
      this.Diferimento = dados[0]._Diferimento;
      this.NaoIncidenci = dados[0]._NaoIncidencia;
      this.Suspensao = dados[0]._Suspensao;

      if (this.digitos != null) {
        for (let da of this.digitos) {
          this.arraySyb.push({ isFalsa: false, a: da.ncm });
        }
      }

      this.cst_pis = this.dadosNcm[0]._cst_piscofins;
      this.pis =
        this.dadosNcm[0]._piscofins.length == 0
          ? ""
          : this.dadosNcm[0]._piscofins[0].piscofins;
      this.descricao =
        this.dadosNcm[0]._NCMDesc.length == 0
          ? ""
          : this.dadosNcm[0]._NCMDesc[0].descricao;
      this.ncmDescIdExcessao = dados[0]._Excessoes;
    },
  },
  async mounted() {
    this.listIcms();
    this.fetchCstData(); // Chama o método para buscar dados CST

    this.spiner = false;
    document.documentElement.scrollTop = 0;
    this.idEstado = this.estados.find(
      (e) => e.sigla == this.$route.params.uf,
    ).id;
    this.dadosSt = await index.getST(this.$route.params.ncm, this.idEstado);
    await Promise.all([
      index
        .NcmEstado(this.$route.params.ncm, this.$route.params.uf)
        .then((dadosNcmUF) => {
          this.dadosNcmUF = dadosNcmUF;
        }),
      index.Ncm(this.$route.params.ncm).then((dadosNcm) => {
        this.dadosNcm = dadosNcm;
      }),
    ]);

    this.extrair(this.dadosNcmUF);
    this.observacao = this.dadosNcm[0]._NCMDesc[0].descricao;
    this.spiner = true;
    let obj = JSON.parse(window.localStorage.getItem("objCli"));
    if (obj.login == "lefisc") {
      window.location = "https://www.lefisc.com.br";
    }
  },
};
</script>
<style>
.hover-text2 {
  display: none;
  position: absolute;
  top: 10px;
  left: 12px;
  font-size: 14px;
  padding: 5px;
  width: 300px;
  max-width: 500px;
  z-index: 1;
  background: #fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.container-excessao {
  width: 100%;
  height: max-content;
  padding: 0;
  border-bottom: 1px solid #4a154b;
  margin-bottom: 20px;
  text-align: start;
}

.container-excessao > h2 {
  color: #4a154b;
  font-weight: 600;
}

.hover-info2:hover > .hover-text2 {
  display: block;
}
.spiner {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 6px solid lightgray;
  border-top-color: #4a154b;
  animation: spinner 0.7s linear infinite;
  margin-top: 3px;
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.viraSeta {
  transform: rotate(180deg);
}
.conteudoIcmsIpi {
  width: 100%;
  margin-top: 3px;
}
.notaPobreza {
  display: inline-block;
  background: #fff3cd !important;
  border-radius: 5px;
  border: 1px solid #ffeeba;
  padding: 15px;
  margin-top: 15px;
}
.txtPobreza {
  font-weight: 600;
}
.txtBo {
  font-weight: bold;
}
.txtWarning {
  color: #ffc107;
}
.espacamento {
  padding: 25px;
  margin-top: 5px;
  background: #ede4ed;
  font-size: 15px;
  text-align: justify;
}
.conteudoIcmsIpi .headerIcmsIpi {
  cursor: pointer;
  width: 100%;
  height: 40px;
  background: #4a154b;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  border-radius: 5px 5px 0px 0px;
  padding: 25px 0px;
  display: flex;
  align-items: center;
  justify-content: start;
}
.textExcessoes {
  width: 100%;
  background: blue;
}
.topPainel {
  background-image: url("/mapatributario/img/b.jpg");
  background-color: #4a154b;
  background-size: cover;
  background-position-y: -455px;
  background-blend-mode: multiply;
  position: relative;
  height: 14vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ajuste {
  padding: 0px 40px;
}
.item {
  text-align: center;
}
.item .primeiroP {
  color: #4a154b;
  font-size: 26px;
  font-weight: bold;
  border-bottom: 1px solid #4a154b;
  width: 350px;
  margin: 0 auto;
}
</style>
